import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Router, Switch } from "react-router-dom";
import { history } from "@helpers/history";
import TagManager from "react-gtm-module";
import { animations } from "react-animation";
import "styles/App.css";
import { pushUserData } from "app/@Base/store/actions/user.actions";
import { pushToken } from "./@Base/store/actions/cmsAuth.actions";
import reqLogin from "app/Auth/services/auth.service";
import reqLoginCMS from "app/Auth/services/auth.serviceCMS";
import useCatalogs from "app/hooks/useCatalogs";
import * as components from "@components";

import { getAnonymPass } from "@helpers/utils";

const anonymuser = process.env.REACT_APP_ANONYM_CRED;
const anonympass = getAnonymPass();

//Template components
const AppBar = components.AppBar;
const SecondaryNavBar = components.SecondaryNavBar;
const Footer = components.Footer;
const ChatForm = components.ChatForm;
const ChatFormulario = components.ChatFormulario;
const NotFound = components.NotFound;

//Content components
const Home = components.Home;

const HomeAhorro = components.HomeAhorro;
const Serviahorro = components.Serviahorro;
const Inversiones = components.Inversiones;
const Contactenos = components.Contactenos;
const Sucursales = components.Sucursales;
const Convenios = components.Convenios;
const CreditosPersonales = components.CreditosPersonales;
const CreditosHipotecarios = components.CreditosHipotecarios;
const CreditosProductivos = components.CreditosProductivos;
const AhorrosProgramados = components.AhorrosProgramados;
const PlanesAsistenciaContainer = components.PlanesAsistenciaContainer;
const TarjetasContainer = components.TarjetasContainer;
const CreditosPersonalesListado = components.CreditosPersonalesListado;
const CreditosHipotecariosListado = components.CreditosHipotecariosListado;
const CreditosProductivosListado = components.CreditosProductivosListado;
const AhorrosProgramadosListado = components.AhorrosProgramadosListado;
const Bienes = components.Bienes;
const Afiliacion = components.Afiliacion;
const Organizacion = components.Organizacion;
const DelegadoContainer = components.DelegadoContainer;
const FirmaDigital = components.FirmaDigital;
const Reglamentos = components.Reglamentos;
const Promociones = components.Promociones;

function App() {

  const dispatch = useDispatch();
  const rutas = [
    {
      "name": "HomeAhorroYCredito",
      "keywords": "Dinero, dinero, exito, éxito, metas, Metas, objetivos, Objetivo, Ahorro y Crédito, ahorro, credito, crédito, coope, coopeservidores, Coopeservidores",
      "title": "CS Ahorro y Crédito en Costa Rica",
      "h1": "Préstamos y ahorros de manera fácil y sencilla con CS",
      "description": "Alcance sus metas y objetivos personales, solicitando uno de nuestros préstamos personales y ahorros de CS.",
      "url": "/",
      "component": "Home",
      "identificadorSitio": "AC"
    },
    {
      "name": "Sucursales",
      "keywords": "Sucursales, sucursales, Sucursal, sucursal,",
      "title": "Sucursales | Ahorro y Crédito",
      "h1": "Sucursales",
      "description": "Encuentre la información de todas las sucursales de nuestra institución.",
      "url": "/sucursales",
      "component": "Sucursales",
      "identificadorSitio": "AC"
    }
  ]
  const { token } = useSelector(({ Base }) => Base.Token);

  const creds = {
    username: anonymuser,
    password: anonympass,
  };

  useEffect(() => {
    if (token === "") {
      reqLoginCMS()
        .then((response) => {
          dispatch(pushToken(response.access_token));
        })
        .catch((error) => {
          // notificacion
        });
    }
    if (Object.entries(creds).length !== 0) {
      reqLogin(creds)
        .then((response) => {
          dispatch(pushUserData(response));
        })
        .catch((error) => {
          // notificacion
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useCatalogs();

  //Inventario de componentes con contenido
  const COMPONENTES = {
    Home: Home,
    HomeAhorro: HomeAhorro,
    Serviahorro: Serviahorro,
    Inversiones: Inversiones,
    Sucursales: Sucursales,
    Convenios: Convenios,
    CreditosPersonales: CreditosPersonales,
    CreditosHipotecarios: CreditosHipotecarios,
    CreditosProductivos: CreditosProductivos,
    AhorrosProgramados: AhorrosProgramados,
    Contactenos: Contactenos,
    PlanesAsistenciaContainer: PlanesAsistenciaContainer,
    TarjetasContainer: TarjetasContainer,
    CreditosPersonalesListado: CreditosPersonalesListado,
    CreditosHipotecariosListado: CreditosHipotecariosListado,
    AhorrosProgramadosListado,
    Afiliacion: Afiliacion,
    Bienes: Bienes,
    ChatForm: ChatForm,
    Organizacion: Organizacion,
    CreditosProductivosListado: CreditosProductivosListado,
    DelegadoContainer: DelegadoContainer,
    FirmaDigital: FirmaDigital,
    Reglamentos: Reglamentos,
    Promociones: Promociones,
    NotFound: NotFound,
    ChatFormulario: ChatFormulario,
  };

  const COMPONENT_DEFAULT = () => Home;

  const tagManagerArgs = {
    gtmId: "GTM-PVWD6RM",
  };

  TagManager.initialize(tagManagerArgs);

  const getRouting = () => {
    if (rutas) {
      return rutas.map((ruta, index) => {
        return {
          name: ruta.name,
          title: ruta.title,
          h1: ruta.h1,
          description: ruta.description,
          url: ruta.url,
          component: COMPONENTES[ruta.component]
            ? COMPONENTES[ruta.component]
            : COMPONENT_DEFAULT,
        };
      });
    }
  };

  return (
    <Router history={history}>
      <div className="App d-flex flex-column">
        <div>
          <AppBar />
          <SecondaryNavBar />
        </div>
        <div
          className=""
          id="main-content"
          style={{ animation: animations.fadeIn }}
        >
          <Switch>
            {rutas &&
              getRouting().map((ruta, index) => {
                return (
                  <Route
                    key={index}
                    path={ruta.url}
                    exact
                    component={ruta.component}
                  />
                );
              })}
            <Route path="*" component={Home}/>
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
